import React, { Component } from "react";

import { handleStep } from "./../Utils/steps";

import StepOptionsCheckbox from "./StepOptions/StepOptionsCheckbox";
import StepOptionsRadio from "./StepOptions/StepOptionsRadio";
import Loader from "./../layout/Loader/Loader";

export class StepOptions extends Component {
  state = {
    step: null,
    stepParamURL: 2
  };

  componentDidMount() {
    this.handleStep();
  }

  componentDidUpdate() {
    this.handleStep();
  }

  handleStep = () => {
    const { stepParamURL, wizardData, steps } = this.props;
    const stepData = handleStep(
      this.props,
      stepParamURL,
      wizardData,
      steps,
      this.state
    );

    if (stepData) {
      stepData.then(data => {
        const step = data[0];
        this.setState({
          step,
          stepParamURL
        });
      });
    }
  };

  render() {
    const { stepParamURL } = this.props;
    const { step } = this.state;

    return (
      <div data-test="StepOptionsComponent" className="pt-3 pt-md-0">
        {!step && (
            <div className="center-xs">
              <Loader />
            </div>
          )}
        {stepParamURL && (
          <div>
            {step && step.addon_effect === "addon" && (
              <StepOptionsCheckbox step={step} props={this.props} />
            )}
            {step && step.addon_effect === "effect" && (
              <StepOptionsRadio step={step} props={this.props} />
            )}
            {/*<Features route={this.props} />*/}
          </div>
        )}
      </div>
    );
  }
}

export default StepOptions;
